import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { GYM, waLink } from "@/lib/gymData";

export const Footer = () => {
  return (
    <footer data-testid="footer-section" className="relative bg-[#0d0d0d] border-t border-white/10">
      {/* Big CTA */}
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-blaze text-xs uppercase tracking-[0.3em] mb-5"
        >
          Join Today
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-display text-white leading-[0.85] tracking-tight text-[16vw] sm:text-[12vw] lg:text-[10rem]"
        >
          YOUR JOURNEY
          <br />
          <span className="text-blaze">STARTS HERE</span>
        </motion.h2>
        <p className="mt-6 text-neutral-400 uppercase tracking-[0.25em] text-xs sm:text-sm">
          Train Hard · Stay Strong · Never Give Up
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="inline-flex items-center gap-2 bg-blaze hover:bg-blaze-hover text-black uppercase tracking-[0.15em] font-semibold text-sm px-8 py-4 rounded-sm hover:shadow-[0_10px_30px_-8px_rgba(245,179,1,0.6)] transition-[background-color,box-shadow]"
          >
            <MessageCircle size={18} /> Join on WhatsApp
          </a>
          <a
            href={`tel:${GYM.phone}`}
            data-testid="footer-call-button"
            className="inline-flex items-center gap-2 border border-white/25 hover:border-blaze text-white uppercase tracking-[0.15em] font-medium text-sm px-8 py-4 rounded-sm hover:text-blaze transition-colors"
          >
            <Phone size={18} /> {GYM.phone}
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img
              src={GYM.logoCircle}
              alt="Fitness Point Gym"
              className="h-11 w-11 object-contain rounded-full ring-1 ring-white/10"
            />
            <p className="font-display text-2xl tracking-tight text-white">
              FITNESS POINT <span className="text-blaze">GYM</span>
            </p>
          </div>
          <p className="text-neutral-500 text-xs tracking-wide text-center sm:text-right">
            © {new Date().getFullYear()} Fitness Point Gym · {GYM.location}
          </p>
        </div>
      </div>
    </footer>
  );
};
